<template>
  <div>
    <search-form
      :model="searchParams"
      :col="3"
      :items="searchConfigList"
      :loading="loading"
      inline
      :action-block="false"
      label-width="100px"
      @submit="handleSearch"
    ></search-form>

    <br>

    <el-table v-loading="loading" :data="tableData">
      <el-table-column label="申诉子单号" width="125" prop="subApplicationOrder"></el-table-column>
      <el-table-column label="申诉子状态" width="100" v-slot="{ row }">
        {{ appealSubStatusMap[row.subStatus] }}
      </el-table-column>
      <el-table-column label="授权方信息" prop="authorizer" width="125"></el-table-column>
      <el-table-column label="涉及歌曲数量" width="100" prop="tracklistCount"></el-table-column>
      <el-table-column label="确认开始时间" width="170" prop="subInsertTime"></el-table-column>
      <el-table-column label="最近一个确权时间" width="170" prop="expiresTime"></el-table-column>
      <el-table-column label="当前确权人" width="100" prop="operateUser"></el-table-column>
      <el-table-column
        label="操作"
        width="80"
        fixed="right"
        align="center"
        v-slot="{ row }"
      >
        <el-button type="text" size="small" @click="handleDetail(row)">查看明细</el-button>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pagination.current"
      :page-sizes="[20, 50, 100, 1000, 2000]"
      :page-size="pagination.size"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      class="pagination"
    >
    </el-pagination>
  </div>
</template>

<script>
import { SubComplaint } from '@/models/Complaint'
import complaintService from '@/api/complaint'
import { paginationTableMixin } from '@/utils/mixins'
import SearchForm from '@/components/SearchForm'
import {
  appealTypeMap,
  appealSubStatusMap,
  levelOneAppealMap,
  levelTwoAppealMap
} from '../../../../../../const'

const isUnf = undefined

function defaultSearchParams() {
  return {
    subApplicationOrder: '',
    appealOrder: '',
    appealTitle: '',
    applicationType: isUnf,
    bussType: isUnf,
    complaintType: isUnf,
    subStatus: isUnf,
    applicationTime: '',
    subInsertTime: '',
    applicationUser: '',
    createUser: ''
  }
}

const searchConfigList = [
  {
    label: '申诉子单号',
    key: 'subApplicationOrder',
    type: 'text',
    componentProps: {
      placeholder: '请输入申诉单号',
      clearable: true
    }
  },
  {
    label: '申诉子状态',
    key: 'subStatus',
    type: 'select',
    options: appealSubStatusMap,
    componentProps: {
      clearable: true
    }
  }
]

export default {
  name: 'CpConfirmTable',
  components: {
    SearchForm
  },
  mixins: [paginationTableMixin],
  data() {
    return {
      appealSubStatusMap,
      appealTypeMap,
      levelOneAppealMap,
      levelTwoAppealMap,
      searchConfigList,

      searchParams: defaultSearchParams(),
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    getParams() {
      const { searchParams } = this
      return searchParams
    },
    async fetchData() {
      this.loading = true
      const params = this.getParams()
      try {
        const { total, list } = await complaintService.querySubComplaintForUser({
          ...params,
          appealId: +this.$route.query.id,
          calTrack: 1,
          page: this.pagination.current - 1,
          num: this.pagination.size
        })
        this.pagination.total = total
        this.tableData = (list || []).map(row => new SubComplaint(row))
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error',
          error
        })
      }
      this.loading = false
    },
    handleDetail(row) {
      this.$emit('go-match', row.subApplicationOrder)
    },
  }
}
</script>

<style lang="scss" scoped>

.search-form {
  ::v-deep {
    .el-card__body {
      padding-bottom: 8px;
    }
    .el-form-item--mini.el-form-item {
      margin-bottom: 12px;

      .el-form-item__label {
        color: #002444;
      }
    }
  }
}

.table-control {
  margin-bottom: 14px;
}

/deep/ .el-table__cell .cell .el-button + .el-button {
  margin-left: 0;
}
</style>
